module.exports = __webpack_public_path__ + "img/DJI_0023.2b8eaff7.jpg";